import React from 'react';

export default function MembersMarketingOptIn() {
  return (
    <label className="members-secondary flex items-start gap-3 text-sm leading-relaxed">
      <input type="checkbox" name="marketing_opt_in" defaultChecked={false} className="mt-1 shrink-0" />
      <span>Quero receber novidades, conteúdos e ofertas da Sminy por e-mail. Posso cancelar a qualquer momento.</span>
    </label>
  );
}
